import React, { useState, useEffect } from 'react';
import { zcUsecaseTexts } from '../contexts/LangZC';
import motorImg from '../assets/images/primx/motor.png';
import motorPdf from '../assets/files/PRIMX_USECASE_motor.pdf';
import airportImg from '../assets/images/primx/airport.png';
import airportPdf from '../assets/files/PRIMX_USECASE_airports.pdf';
import medicalImg from '../assets/images/primx/medical.png';
import medicalPdf from '../assets/files/PRIMX_USECASE_medical.pdf';
import eduImg from '../assets/images/primx/edu.png';
import eduPdf from '../assets/files/PRIMX_USECASE_edu.pdf';

// 1번 카드
function ProductZCUSmotor({ lang = 'ko', isMobile = false }) {
  const [isMotorHover, setIsMotorHover] = useState(false);

  return (
    <>
      <div style={{
        fontSize: isMobile ? '1.2rem' : '1.35rem',
        fontWeight: 700,
        marginBottom: isMobile ? 12 : 16
      }}>
        {zcUsecaseTexts.motor[lang]}
      </div>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: 16,
          flexShrink: 0,
          position: 'relative'
        }}
        onMouseEnter={() => setIsMotorHover(true)}
        onMouseLeave={() => setIsMotorHover(false)}
      >
        <img
          src={motorImg}
          alt="motor"
          style={{
            width: 'auto',
            height: isMobile ? 280 : 380,
            maxWidth: '95%',
            objectFit: 'contain',
            imageRendering: 'auto',
            display: 'block'
          }}
        />
        {isMotorHover && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: 460,
              height: 380,
              background: 'rgba(41,34,92,0.72)',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.25rem',
              fontWeight: 700,
              zIndex: 2,
              pointerEvents: 'none',
              textAlign: 'center',
              padding: 16,
              borderRadius: 12,
              boxSizing: 'border-box'
            }}
          >
            {zcUsecaseTexts.motortitle[lang]}
            <br /><br />{zcUsecaseTexts.motorsubtitle[lang]}
          </div>
        )}
      </div>
      <div style={{ flex: 1 }} />
      <a
        href={motorPdf}
        download="PRIMX_USECASE_motor.pdf"
        style={{
          marginBottom: isMobile ? 24 : 32,
          padding: isMobile ? '10px 24px' : '12px 32px',
          borderRadius: 8,
          border: 'none',
          background: '#29225C',
          color: '#fff',
          fontWeight: 700,
          fontSize: isMobile ? '1rem' : '1.08rem',
          cursor: 'pointer',
          textDecoration: 'none',
          display: 'inline-block',
          textAlign: 'center'
        }}
      >
        {zcUsecaseTexts.edudownload[lang]}
      </a>
    </>
  );
}

// 2번 카드
function ProductZCUSairport({ lang = 'ko', isMobile = false }) {
  const [isAirportHover, setIsAirportHover] = useState(false);

  return (
    <>
      <div style={{
        fontSize: isMobile ? '1.2rem' : '1.35rem',
        fontWeight: 700,
        marginBottom: isMobile ? 12 : 16
      }}>
        {zcUsecaseTexts.airport[lang]}
      </div>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: 16,
          flexShrink: 0,
          position: 'relative'
        }}
        onMouseEnter={() => setIsAirportHover(true)}
        onMouseLeave={() => setIsAirportHover(false)}
      >
        <img
          src={airportImg}
          alt="airport"
          style={{
            width: 'auto',
            height: isMobile ? 280 : 380,
            maxWidth: '95%',
            objectFit: 'contain',
            imageRendering: 'auto',
            display: 'block'
          }}
        />
        {isAirportHover && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: isMobile ? 320 : 460,
              height: isMobile ? 280 : 380,
              background: 'rgba(41,34,92,0.72)',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: isMobile ? '1.1rem' : '1.25rem',
              fontWeight: 700,
              zIndex: 2,
              pointerEvents: 'none',
              textAlign: 'center',
              padding: isMobile ? 12 : 16,
              borderRadius: 12,
              boxSizing: 'border-box'
            }}
          >
            {zcUsecaseTexts.airporttitle[lang]}
            <br /><br />{zcUsecaseTexts.airportsubtitle[lang]}
          </div>
        )}
      </div>
      <div style={{ flex: 1 }} />
      <a
        href={airportPdf}
        download="PRIMX_USECASE_airports.pdf"
        style={{
          marginBottom: isMobile ? 24 : 32,
          padding: isMobile ? '10px 24px' : '12px 32px',
          borderRadius: 8,
          border: 'none',
          background: '#29225C',
          color: '#fff',
          fontWeight: 700,
          fontSize: isMobile ? '1rem' : '1.08rem',
          cursor: 'pointer',
          textDecoration: 'none',
          display: 'inline-block',
          textAlign: 'center'
        }}
      >
        {zcUsecaseTexts.edudownload[lang]}
      </a>
    </>
  );
}

// 3번 카드
function ProductZCUSmedical({ lang = 'ko', isMobile = false }) {
  const [isMedicalHover, setIsMedicalHover] = useState(false);

  return (
    <>
      <div style={{
        fontSize: isMobile ? '1.2rem' : '1.35rem',
        fontWeight: 700,
        marginBottom: isMobile ? 12 : 16
      }}>
        {zcUsecaseTexts.medical[lang]}
      </div>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: 16,
          flexShrink: 0,
          position: 'relative'
        }}
        onMouseEnter={() => setIsMedicalHover(true)}
        onMouseLeave={() => setIsMedicalHover(false)}
      >
        <img
          src={medicalImg}
          alt="medical"
          style={{
            width: 'auto',
            height: isMobile ? 280 : 380,
            maxWidth: '95%',
            objectFit: 'contain',
            imageRendering: 'auto',
            display: 'block'
          }}
        />
        {isMedicalHover && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: isMobile ? 320 : 460,
              height: isMobile ? 280 : 380,
              background: 'rgba(41,34,92,0.72)',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: isMobile ? '1.1rem' : '1.25rem',
              fontWeight: 700,
              zIndex: 2,
              pointerEvents: 'none',
              textAlign: 'center',
              padding: isMobile ? 12 : 16,
              borderRadius: 12,
              boxSizing: 'border-box'
            }}
          >
            {zcUsecaseTexts.medicaltitle[lang]}
            <br /><br />{zcUsecaseTexts.medicalsubtitle[lang]}
          </div>
        )}
      </div>
      <div style={{ flex: 1 }} />
      <a
        href={medicalPdf}
        download="PRIMX_USECASE_medical.pdf"
        style={{
          marginBottom: isMobile ? 24 : 32,
          padding: isMobile ? '10px 24px' : '12px 32px',
          borderRadius: 8,
          border: 'none',
          background: '#29225C',
          color: '#fff',
          fontWeight: 700,
          fontSize: isMobile ? '1rem' : '1.08rem',
          cursor: 'pointer',
          textDecoration: 'none',
          display: 'inline-block',
          textAlign: 'center'
        }}
      >
        {zcUsecaseTexts.edudownload[lang]}
      </a>
    </>
  );
}

// 4번 카드
function ProductZCUSedu({ lang = 'ko', isMobile = false }) {
  const [isEduHover, setIsEduHover] = useState(false);

  return (
    <>
      <div style={{
        fontSize: isMobile ? '1.2rem' : '1.35rem',
        fontWeight: 700,
        marginBottom: isMobile ? 12 : 16
      }}>
        {zcUsecaseTexts.edu[lang]}
      </div>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginBottom: 16,
          flexShrink: 0,
          position: 'relative'
        }}
        onMouseEnter={() => setIsEduHover(true)}
        onMouseLeave={() => setIsEduHover(false)}
      >
        <img
          src={eduImg}
          alt="edu"
          style={{
            width: 'auto',
            height: isMobile ? 280 : 380,
            maxWidth: '95%',
            objectFit: 'contain',
            imageRendering: 'auto',
            display: 'block'
          }}
        />
        {isEduHover && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: '50%',
              transform: 'translateX(-50%)',
              width: isMobile ? 320 : 460,
              height: isMobile ? 280 : 380,
              background: 'rgba(41,34,92,0.72)',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: isMobile ? '1.1rem' : '1.25rem',
              fontWeight: 700,
              zIndex: 2,
              pointerEvents: 'none',
              textAlign: 'center',
              padding: isMobile ? 12 : 16,
              borderRadius: 12,
              boxSizing: 'border-box'
            }}
          >
            {zcUsecaseTexts.edutitle[lang]}
            <br /><br />{zcUsecaseTexts.edusubtitle[lang]}
          </div>
        )}
      </div>
      <div style={{ flex: 1 }} />
      <a
        href={eduPdf}
        download="PRIMX_USECASE_edu.pdf"
        style={{
          marginBottom: isMobile ? 24 : 32,
          padding: isMobile ? '10px 24px' : '12px 32px',
          borderRadius: 8,
          border: 'none',
          background: '#29225C',
          color: '#fff',
          fontWeight: 700,
          fontSize: isMobile ? '1rem' : '1.08rem',
          cursor: 'pointer',
          textDecoration: 'none',
          display: 'inline-block',
          textAlign: 'center'
        }}
      >
        {zcUsecaseTexts.edudownload[lang]}
      </a>
    </>
  );
}

function ProductZCUsecase({ lang = 'ko', isMobile = false }) {
  const [isInternalMobile, setIsInternalMobile] = useState(false);
  
  useEffect(() => {
    const checkMobile = () => {
      setIsInternalMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // isMobile prop이 전달되면 그것을 사용하고, 그렇지 않으면 내부 상태 사용
  const mobile = isMobile || isInternalMobile;

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#29225C',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: mobile ? '32px 16px' : '48px 16px'
      }}
    >
      <h1 style={{
        fontSize: mobile ? '2rem' : '2.5rem',
        fontWeight: 700,
        color: '#fff',
        marginTop: mobile ? 40 : 60,
        marginBottom: mobile ? 32 : 40,
        textAlign: 'center'
      }}>
        {zcUsecaseTexts.title[lang]}
      </h1>
      {/* 반응형 카드 박스 4개 */}
      <div
        className="zc-usecase-flex"
        style={{
          display: 'flex',
          flexDirection: mobile ? 'column' : 'row',
          flexWrap: mobile ? 'nowrap' : 'wrap',
          gap: mobile ? 20 : 32,
          justifyContent: 'center',
          alignItems: mobile ? 'center' : 'stretch',
          width: '100%',
          maxWidth: mobile ? '100%' : 1000,
          marginBottom: mobile ? 32 : 40
        }}
      >
        {[ProductZCUSmotor, ProductZCUSairport, ProductZCUSmedical, ProductZCUSedu].map((Component, idx) => (
          <div
            key={idx}
            style={{
              flex: mobile ? 'none' : '1 1 330px',
              width: mobile ? '100%' : 'auto',
              minWidth: mobile ? 'auto' : 330,
              maxWidth: mobile ? '400px' : 460,
              height: mobile ? 'auto' : 500,
              minHeight: mobile ? '420px' : 500,
              background: '#035BFB',
              borderRadius: 16,
              boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'flex-start',
              fontSize: mobile ? '1.1rem' : '1.25rem',
              fontWeight: 600,
              color: '#fff',
              paddingTop: mobile ? 24 : 32,
              paddingBottom: mobile ? 20 : 0
            }}
          >
            <Component lang={lang} isMobile={mobile} />
          </div>
        ))}
      </div>

      {/* 금융 사례 내용을 여기에 추가하세요 */}
    </div>
  );
}

export default ProductZCUsecase;